const Profile = () => import('../views/Profile.vue')

export default [
  {
    path: '/partner/profile',
    component: Profile,
    meta: { requiresAuth: true },
    name: 'partner.profile'
  }
]